// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SummerSection_1,.SummerSection_2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.SummerSection_btngrid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}
.SummerSection_btn1,.SummerSection_btn2,.SummerSection_btn3,.SummerSection_btn4 {
    padding: 10px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    margin: 2vh;
}
.SummerSection_btn1{
    background-color:#2fdb1f ;
}
.SummerSection_btn2{
    background-color:#9b68d9 ;
}
.SummerSection_btn3{
    background-color:#dbaf1f ;
}
.SummerSection_btn4{
    background-color:#688cd9 ;
}
.SummerSection_video{
    width: 100%;
    display: flex;
    justify-content: center;
}

.SummerCamp24{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.SummerCamp24 b{
    color: #8b0194;
    font-weight: bold;
    font-size: 8vh;
    font-family: cursive;
}
.SummerCamp24 p{
    color: #ddaf1f;
    font-weight: bold;
    width: 80%;
}

.Summer_countries{
    display: flex;
    align-items: center;
    justify-content: center;
}
.Summer_country{
    text-align: center;
    width: 15vw;
    height: 30vh;
    padding: 3%;
    /* background-color: #cd99f7; */
    border-radius: 15vh;
}
.Summer_country b{
    font-weight: bold;
    color: white;
}
.SummerCamp_CoursesCards{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.SummerCamp_CoursesCard{
    display: flex;
    flex-direction: column;
    border-radius: 2vh;
    margin: 1vh;
    width: 25vw;
}

.SummerCourseCard{
    border-radius: 2vh;
    display: flex;
    background-color: #0a6fda;
    padding: 1vh;
}
.Section1_CoursesCard{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    color: white;
    padding: 4%;
}
.Section1_CoursesCard b{
    font-size: 4vh;
    font-family: cursive;
}
.CoursesCards_Image{
    width: auto;
}

.Section2_CoursesCard {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 20px;
    width: auto; 
    margin: auto;
    text-align: center;
}
.Section2_CoursesCard div {
    padding: 10px;
}
.Section2_CoursesCard .header {
    font-weight: bold;
    font-size: 2.5vh;
}
.Section3_CoursesCard{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.Section3_CoursesCard h3{
    font-size: larger;
    font-family: cursive;
    font-weight: bold;
    color: white;
}
.SummerCamp_CourseDetailbtn{
    padding: 3% 5% 3% 5%;
    color: white;
    font-weight: bold;
    border-radius: 1vh;
    margin: 2vh;
}

@media (max-width: 768px) {
    
    .SummerSection_1{
        width: -webkit-fill-available;
    }

    .SummerSection_btngrid{
        flex-direction: column;
        display: flex;
    }
    .SummerCamp_Image img{
        width: 90vw;
    }
    .Summer_countries{
        flex-direction: column;
    }
    .Summer_country{
        width: auto;
        height: auto;
        margin: 1vh;
    }
    .SummerCamp_CoursesCards{
        flex-direction: column;
    }
    .SummerCamp_CoursesCard{
        width: auto;
    }
    .CoursesCards_Image img{
        width: 30vw !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/PromotionalPages/SummerCamp.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,+BAA+B;IAC/B,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;AACA;IACI,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;QACtB,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".SummerSection_1,.SummerSection_2 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.SummerSection_btngrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n.SummerSection_btn1,.SummerSection_btn2,.SummerSection_btn3,.SummerSection_btn4 {\n    padding: 10px;\n    color: #fff;\n    text-align: center;\n    cursor: pointer;\n    font-weight: bold;\n    margin: 2vh;\n}\n.SummerSection_btn1{\n    background-color:#2fdb1f ;\n}\n.SummerSection_btn2{\n    background-color:#9b68d9 ;\n}\n.SummerSection_btn3{\n    background-color:#dbaf1f ;\n}\n.SummerSection_btn4{\n    background-color:#688cd9 ;\n}\n.SummerSection_video{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.SummerCamp24{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.SummerCamp24 b{\n    color: #8b0194;\n    font-weight: bold;\n    font-size: 8vh;\n    font-family: cursive;\n}\n.SummerCamp24 p{\n    color: #ddaf1f;\n    font-weight: bold;\n    width: 80%;\n}\n\n.Summer_countries{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.Summer_country{\n    text-align: center;\n    width: 15vw;\n    height: 30vh;\n    padding: 3%;\n    /* background-color: #cd99f7; */\n    border-radius: 15vh;\n}\n.Summer_country b{\n    font-weight: bold;\n    color: white;\n}\n.SummerCamp_CoursesCards{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\n.SummerCamp_CoursesCard{\n    display: flex;\n    flex-direction: column;\n    border-radius: 2vh;\n    margin: 1vh;\n    width: 25vw;\n}\n\n.SummerCourseCard{\n    border-radius: 2vh;\n    display: flex;\n    background-color: #0a6fda;\n    padding: 1vh;\n}\n.Section1_CoursesCard{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    color: white;\n    padding: 4%;\n}\n.Section1_CoursesCard b{\n    font-size: 4vh;\n    font-family: cursive;\n}\n.CoursesCards_Image{\n    width: auto;\n}\n\n.Section2_CoursesCard {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    padding: 20px;\n    width: auto; \n    margin: auto;\n    text-align: center;\n}\n.Section2_CoursesCard div {\n    padding: 10px;\n}\n.Section2_CoursesCard .header {\n    font-weight: bold;\n    font-size: 2.5vh;\n}\n.Section3_CoursesCard{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.Section3_CoursesCard h3{\n    font-size: larger;\n    font-family: cursive;\n    font-weight: bold;\n    color: white;\n}\n.SummerCamp_CourseDetailbtn{\n    padding: 3% 5% 3% 5%;\n    color: white;\n    font-weight: bold;\n    border-radius: 1vh;\n    margin: 2vh;\n}\n\n@media (max-width: 768px) {\n    \n    .SummerSection_1{\n        width: -webkit-fill-available;\n    }\n\n    .SummerSection_btngrid{\n        flex-direction: column;\n        display: flex;\n    }\n    .SummerCamp_Image img{\n        width: 90vw;\n    }\n    .Summer_countries{\n        flex-direction: column;\n    }\n    .Summer_country{\n        width: auto;\n        height: auto;\n        margin: 1vh;\n    }\n    .SummerCamp_CoursesCards{\n        flex-direction: column;\n    }\n    .SummerCamp_CoursesCard{\n        width: auto;\n    }\n    .CoursesCards_Image img{\n        width: 30vw !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
